import gql from 'graphql-tag';

export const appConnectionsScreenQuery = gql`
  query appConnectionsScreen {
    appConnectionsScreen {
      ... on AppExternalActivity {
        image {
          source
        }
        icon
        name
        institution {
          id
        }
      }
    }
  }
`;
